
import * as defaultImport from "@splunk/visualization-encoding/utils/deepMergeWithArrayPrimitiveOverrides";
export * from "@splunk/visualization-encoding/utils/deepMergeWithArrayPrimitiveOverrides";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
